import { useSelector } from 'react-redux';

const containsProperty = (object, key) => {
  object ||= {};

  return object.hasOwnProperty(key) && object[key] !== null;
};

export const usePreference = (key, defaultValue) => useSelector((state) => {
  if (state.session.server.forceSettings) {
    if (containsProperty(state.session.server, key)) {
      return state.session.server[key];
    }
    if (containsProperty(state.session.user, key)) {
      return state.session.user[key];
    }
    return defaultValue;
  }
  if (containsProperty(state.session.user, key)) {
    return state.session.user[key];
  }
  if (containsProperty(state.session.server, key)) {
    return state.session.server[key];
  }
  return defaultValue;
});

export const useAttributePreference = (key, defaultValue) =>
  useSelector((state) => {
    //console.debug('[useAttributePreference] key:', key);
    //console.debug('[useAttributePreference] defaultValue:', defaultValue);
    //console.debug('[useAttributePreference] forceSettings:', state.session.server.forceSettings);

    if (state.session.server.forceSettings) {
      if (containsProperty(state.session.server.attributes, key)) {
        const value = state.session.server.attributes[key];
        //console.debug('[useAttributePreference] RETURN server attribute (forced):', value);
        return value;
      }

      if (containsProperty(state.session.user?.attributes || {}, key)) {
        const value = state.session.user.attributes[key];
        //console.debug('[useAttributePreference] RETURN user attribute (forced fallback):', value);
        return value;
      }

      //console.debug('[useAttributePreference] RETURN defaultValue (forced, no attributes)');
      return defaultValue;
    }

    if (containsProperty(state.session.user?.attributes || {}, key)) {
      const value = state.session.user.attributes[key];
      //console.debug('[useAttributePreference] RETURN user attribute:', value);
      return value;
    }

    if (containsProperty(state.session.server.attributes, key)) {
      const value = state.session.server.attributes[key];
      //console.debug('[useAttributePreference] RETURN server attribute:', value);
      return value;
    }

    //console.debug('[useAttributePreference] RETURN defaultValue (no attributes)');
    return defaultValue;
  });

